(function () {
  'use strict';
  var H = window.HWP;
  if (!H) return;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  // dr204-2 (dry 3 types): show each variant as two lines (name + spec) and add a "No.1" badge next to the heading.
  // Options, prices and cart values are not changed; only the look is replaced.
  function dry() {
    var vp = q('.product-info__block-item[data-block-type="variant-picker"] variant-picker');
    if (!vp) return false;
    var labels = qa('label.block-swatch', vp);
    if (!labels.length) return false;
    vp.setAttribute('data-hwp', 'dry');
    labels.forEach(function (lab) {
      if (lab.classList.contains('is-hwp')) return;
      var span = q('.block-swatch__label', lab);
      if (!span) return;
      var text = span.textContent.trim();
      var m = text.match(/^(.*?)\s*[\(（](.*)[\)）]\s*$/);
      var name = m ? m[1] : text;
      var spec = m ? m[2] : '';
      var body = el('span', 'hwp__body');
      body.appendChild(el('span', 'hwp__name', name));
      if (spec) body.appendChild(el('span', 'hwp__spec', spec));
      lab.insertBefore(body, span);
      lab.classList.add('is-hwp');
    });
    if (!q('.hwp-badge--head', vp)) {
      var head = null;
      qa('legend, .variant-picker__option-label, .variant-picker__option-info, span, p, div', vp).some(function (n) {
        if (n.closest('label')) return false;
        if (n.children.length > 3) return false;
        if (n.textContent.indexOf('試したい') > -1 && n.textContent.length < 40) { head = n; return true; }
        return false;
      });
      if (head) {
        var b = el('span', 'hwp-badge hwp-badge--head', '人気No.1：フィッシュ');
        b.style.display = 'inline-block';
        b.style.marginLeft = '10px';
        b.style.verticalAlign = 'middle';
        b.style.fontWeight = '700';
        head.appendChild(b);
      }
    }
    return true;
  }

  // Initial selection once after page display. Never overwrites a choice made by the customer.
  function setDefault(sel, re) {
    var opt = [].slice.call(sel.options).filter(function (o) { return re.test(o.text.trim()); })[0];
    if (!opt || sel.value === opt.value) return;
    sel.value = opt.value;
    sel.dispatchEvent(new Event('input', { bubbles: true }));
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // True only when the visitor came from the meal guide with age = puppy (diag_age=puppy).
  // The value is kept for the browser session so a reload of the page keeps the same default.
  function fromPuppyDiag() {
    var age = '';
    try { age = new URLSearchParams(window.location.search).get('diag_age') || ''; } catch (e) {}
    try {
      if (age) window.sessionStorage.setItem('hwp_diag_age', age);
      else age = window.sessionStorage.getItem('hwp_diag_age') || '';
    } catch (e) {}
    return age === 'puppy';
  }

  // tp01 (topping trial set): headings and No.1 badges for 2 dry + 2 freeze-dried bags. Options stay as the app provides.
  function tp() {
    var fields = [];
    for (var n = 1; n < 10; n++) {
      var s = q('select[name="properties[' + n + ']"]');
      if (!s) break;
      var f = s.closest('[class*="spb-io-field"]');
      if (!f) return false;
      fields.push(f);
    }
    if (fields.length < 2) return false;
    if (fields[0].classList.contains('hwp-field')) return true;
    var groups = [];
    fields.forEach(function (f) {
      var lab = q('label', f);
      var t = lab ? lab.textContent : '';
      var kind = t.indexOf('フリーズドライ') > -1 ? 'fd' : (t.indexOf('ドライフード') > -1 ? 'dry' : 'other');
      f.classList.add('hwp-field');
      var g = groups[groups.length - 1];
      if (!g || g.kind !== kind) { g = { kind: kind, fields: [f] }; groups.push(g); } else { g.fields.push(f); }
    });
    var pop = { dry: 'フィッシュ', fd: 'チキン&ホキ' };
    var ttl = { dry: 'ドライフード', fd: 'フリーズドライ' };
    groups.forEach(function (g) {
      if (g.kind === 'other') return;
      var h = el('div', 'hwp-group');
      var t = el('span', 'hwp-group__title', ttl[g.kind]);
      t.appendChild(el('small', null, '（' + g.fields.length + '袋）'));
      h.appendChild(t);
      h.appendChild(el('span', 'hwp-badge', '人気No.1：' + pop[g.kind]));
      g.fields[0].parentNode.insertBefore(h, g.fields[0]);
    });
    // Age notice (same wording as the sp-fd-3 stepper note). Added once, for every visitor.
    if (!q('.hwp-age-note')) {
      var last = fields[fields.length - 1];
      var note = el('p', 'hwp-age-note', 'ドライの「ベニソン」とフリーズドライの「チキン&ホキ」は成犬用です。原材料と対象年齢をご確認のうえお選びください。');
      note.style.cssText = 'margin:8px 0 0;font-size:12px;line-height:1.6;color:#7a6553;';
      last.parentNode.insertBefore(note, last.nextSibling);
    }
    if (!window.__hwpDefaults) {
      window.__hwpDefaults = true;
      try {
        var s2 = q('select[name="properties[2]"]');
        var s4 = q('select[name="properties[4]"]');
        if (s2) setDefault(s2, /^チキン(?!&)/);
        if (s4) setDefault(s4, /^ビーフ/);
        // Puppy from the meal guide: the 3rd bag (freeze-dried) must not start on the adult-only Chicken & Hoki.
        if (fromPuppyDiag()) {
          var s3 = q('select[name="properties[3]"]');
          if (s3) setDefault(s3, /^ベニソン/);
        }
      } catch (e) { if (window.console) console.warn('hwp: default skipped', e); }
    }
    return true;
  }

  var run = H.handle === 'dr204-2' ? dry : (H.handle === 'tp01' ? tp : null);
  if (!run) return;

  var busy = false;
  var queued = false;
  function apply() {
    if (busy) return;
    busy = true;
    try { run(); } catch (e) { if (window.console) console.warn('hwp: fallback to original', e); }
    busy = false;
  }
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || window.setTimeout)(function () { queued = false; apply(); });
  }

  apply();
  document.addEventListener('DOMContentLoaded', apply);
  // The theme redraws the option area when the variant changes, so re-apply the same look each time (safe to run repeatedly).
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();